/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
  Modal,
  Button,
  Badge,
} from 'react-bootstrap';
import { injectIntl, intlShape } from 'react-intl';
import Dropzone from 'react-dropzone';
import Papa from 'papaparse';
import CSSModules from 'react-css-modules';
import Toolbar from 'loracoms/Toolbar';
import InlineSelect from 'loracoms/InlineSelect';
import Checkbox from 'loracoms/Checkbox';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import { parseContent } from '../util';
import styles from './styles.scss';

const kEncodingOptions = [{
  label: 'UTF-8',
  value: 'UTF-8',
}, {
  label: 'GBK',
  value: 'GBK',
}];

const kInnerFields = [
  'valid',
  'idx',
  'error',
  'result',
  'missings',
];

const kRequiredFields = [
  'deveui',
  'nodetype',
];

const kListHeaders = ['name', 'deveui', 'nodetype', 'sf', 'gateway', 'remark'];

const propTypes = {
  intl: intlShape.isRequired,
  pushState: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
  networkDetail: PropTypes.object.isRequired,
};

class BatchNodes extends React.Component {
  static norm(rows) {
    let normedRows = _.filter(rows, (r) => {
      if (r.deveui) {
        return r.deveui.trim().length > 0;
      }
      return false;
    });
    normedRows = _.map(normedRows, (r, idx) => {
      let row = { ...r };
      row.idx = idx;
      row.missings = _.filter(kRequiredFields, f => !_.has(row, f) || _.isNil(row[f]) || row[f].trim() === '');
      row.valid = row.missings.length === 0;
      row.error = null;
      row = _.mapKeys(row, (value, key) => key.toLowerCase());
      return row;
    });
    return normedRows;
  }

  constructor(props) {
    super(props);
    const { types } = parseContent(props.typesJSON);
    this.state = {
      view: 'dropzone',
      encoding: 'UTF-8',
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.batch');
    this.types = types;
    this.addQueue = [];
    this.networkDetail = props.networkDetail;
    this.handleDrop = this.handleDrop.bind(this);
    this.handleReImport = this.handleReImport.bind(this);
    this.handleChangeEncoding = this.handleChangeEncoding.bind(this);
    this.handleSubmitImport = this.handleSubmitImport.bind(this);
    this.toggleCheck = this.toggleCheck.bind(this);
    this.toggleCheckAll = this.toggleCheckAll.bind(this);
  }

  componentWillReceiveProps({ typesJSON, networkDetail }) {
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { types } = parseContent(typesJSON);
      this.types = types;
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
  }

  cleanse(rows) {
    const nodetypes = this.types.nodetypes;
    if (!nodetypes) return [];

    let nodes = _.map(rows, (c) => {
      const nt = _.find(nodetypes, n => n.type === c.nodetype) || {};
      const services = nt.services;
      const deveui = _.toLower(c.deveui);
      return {
        ...c,
        deveui,
        id: deveui,
        typ: c.nodetype,
        sf: (!_.isNil(c.sf) && c.sf > 0) ? _.toNumber(c.sf) : null,
        home: !_.isNil(c.gateway) ? _.toLower(c.gateway) : '',
        services,
        memo: JSON.stringify({ remark: c.remark, name: c.name }),
      };
    });
    nodes = _.filter(nodes, n => n.typ && n.services);
    return nodes;
  }

  handleDrop(acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.setState({ file: acceptedFiles[0] });
      this.prepareFile({ file: acceptedFiles[0] });
    }
  }

  prepareFile(options) {
    const {
      file = this.state.file,
      encoding = this.state.encoding,
    } = options;
    if (!file) {
      return;
    }

    const that = this;
    Papa.parse(file, {
      complete: (result) => {
        let rows = BatchNodes.norm(result.data);
        rows = _.filter(rows, { valid: true });
        rows = this.cleanse(rows);
        that.setState({
          rows,
          checkedRows: _.filter(rows, 'valid'),
          view: 'preview',
        });
      },
      header: true,
      encoding,
    });
  }

  handleChangeEncoding(encoding) {
    this.setState({ encoding });
    this.prepareFile({ encoding });
  }

  handleSubmitImport() {
    const {
      rows,
      checkedRows,
      canSubmit = true,
    } = this.state;
    if (!canSubmit) {
      return;
    }
    // !!! Oh yeah, we can do the batch import !!!!

    this.setState({ submitStatus: 'pending' });
    const { id: netw } = this.networkDetail.data || {};
    this.addQueue = _.map(checkedRows, c => ({
      netw,
      id: c.id,
      memo: c.memo,
      services: c.services,
      typ: c.typ,
      sf: (!_.isNil(c.sf) && c.sf > 0) ? _.toNumber(c.sf) : null,
      home: !_.isNil(c.gateway) ? _.toLower(c.gateway) : '',
    }));
    const addFunc = () => {
      if (this.addQueue.length > 0) {
        const node = this.addQueue.pop();
        callAPI({
          method: 'POST',
          endpoint: '/tdmng/nodes',
          body: { ...node },
        }).then(() => {
          _.find(rows, d => d.id === node.id).added = 'success';
          this.setState({ rows });
          addFunc();
        }).catch((err) => {
          _.find(rows, d => d.id === node.id).added = err.code;
          _.find(rows, d => d.id === node.id).errMessage = err.message;
          addFunc();
        });
      } else {
        this.setState({ rows, view: 'result', submitStatus: 'success' });
      }
    };
    addFunc();
  }

  handleReImport() {
    this.setState({
      view: 'dropzone',
      file: null,
    });
  }

  toggleCheck(row) {
    const { checkedRows } = this.state;
    if (_.some(checkedRows, { idx: row.idx })) {
      this.setState({
        checkedRows: _.filter(checkedRows, r => r.idx !== row.idx),
      });
    } else {
      checkedRows.push(row);
      this.setState({ checkedRows });
    }
  }

  toggleCheckAll() {
    const { rows, checkedRows } = this.state;
    const validRows = _.filter(rows, 'valid');
    if (validRows.length === checkedRows.length) {
      this.setState({ checkedRows: [] });
    } else {
      this.setState({ checkedRows: validRows });
    }
  }

  parseResultError(x, m = '') {
    if (_.startsWith(x, 'GENERALERROR')) {
      return this.intlMsg.errorMsg('GENERALERROR');
    }
    if (_.startsWith(x, 'NOTFOUND')) {
      if (m.indexOf('home') > -1 || m.indexOf('gateway') > -1) {
        return this.intlMsg.errorMsg('GTW.NOTFOUND');
      }
      return this.intlMsg.errorMsg('NOTFOUND');
    }
    return `${this.intlMsg.msg('result.fail')}: ${m}`;
  }

  renderTools() {
    const { encoding } = this.state;
    return (
      <div className={styles.tools}>
        <InlineSelect
          options={kEncodingOptions}
          onChange={xs => this.handleChangeEncoding(xs[0])}
          values={[encoding]}
        />
      </div>
    );
  }

  renderDropzone() {
    return (
      <div>
        {this.renderTools()}
        <Dropzone
          className={styles.dropzone}
          activeClassName={styles['dropzone-active']}
          onDrop={this.handleDrop}
        >
          <div className="text-center">
            {this.intlMsg.msg('dropzone.text')}
          </div>
        </Dropzone>
      </div>
    );
  }

  renderPreview() {
    const { canSubmit = true, submitStatus } = this.state;

    const isPending = submitStatus === 'pending';
    const { rows, checkedRows } = this.state;
    let headers = kListHeaders;
    headers = _.filter(headers, h => !kInnerFields.includes(h) && !kRequiredFields.includes(h));
    headers = _.concat(kRequiredFields, headers);
    const ths = headers.map(h => (
      <th key={h} style={{ whiteSpace: 'nowrap' }}>{h}</th>
    ));
    const trs = rows.map((r) => {
      let status = null;
      if (r.added === 'success') {
        status = 'result-succ';
      } else if (!_.isNil(r.added)) {
        status = 'result-fail';
      }
      return (
        <tr key={r.deveui} styleName={`${r.error ? 'result-fail' : ''} ${status || ''}`}>
          <td styleName="f-checkbox">
            {r.error ? <i className="fa fa-times" /> :
            <Checkbox
              id={r.deveui}
              checked={_.some(checkedRows, { idx: r.idx })}
              onChange={() => this.toggleCheck(r)}
              disabled={!r.valid || isPending}
            />
            }
          </td>
          {
            headers.map((h) => {
              let c;
              if (r.missings.includes(h)) {
                c = this.intlMsg.msg('preview.required');
              } else {
                c = r[h];
              }
              return (
                <td
                  key={`${r.deveui}-${h}`}
                  className={r.missings.includes(h) ? styles.missing : ''}
                  style={{ whiteSpace: 'nowrap' }}
                // styleName={sty}
                >
                  {c}
                </td>
              );
            })
          }
        </tr>
      );
    });

    return (
      <div styleName="preview">
        {this.renderTools()}
        <Table
          className="aisz-table-light"
          striped
          responsive
          bordered
          hover
        >
          <thead>
            <tr>
              <th styleName="f-checkbox">
                <Checkbox
                  id="all"
                  disabled={isPending}
                  checked={_.filter(rows, 'valid').length === checkedRows.length}
                  onChange={this.toggleCheckAll}
                />
              </th>
              {ths}
            </tr>
          </thead>
          <tbody>
            {trs}
          </tbody>
        </Table>
        <div styleName="submit">
          <Button bsStyle="aisz-warning" onClick={() => this.setState({ view: 'dropzone' })}>
            <i className="fa fa-repeat" />
            {' '}
            { this.intlMsg.msg('preview.cancel.btn')}
          </Button>
          {' '}
          <Button
            bsStyle="aisz-primary"
            onClick={this.handleSubmitImport}
            disabled={checkedRows.length === 0 || !canSubmit}
          >
            { this.intlMsg.msg('preview.import.btn.seg1') }
            {' '}
            <Badge bsClass="aisz-badge-primary-i">{checkedRows.length}</Badge>
            {' '}
            { this.intlMsg.msg('preview.import.btn.seg2') }
            {' '}
            <i className="fa fa-arrow-circle-o-right" />
          </Button>
        </div>
      </div>
    );
  }

  renderResult() {
    const { rows } = this.state;
    let headers = kListHeaders;
    headers = _.filter(headers, h => !kInnerFields.includes(h));
    const ths = headers.map((h, i) => <th key={i} style={{ whiteSpace: 'nowrap' }}>{h}</th>);    // eslint-disable-line

    const trs = rows.map((r, i) => {
      const status = r.added === 'success' ? 'succ' : 'fail';
      let icon;
      let msg = this.intlMsg.msg('result.notimport');
      if (status === 'succ') {
        icon = <i className="fa fa-check" />;
        msg = this.intlMsg.msg('result.succ');
      } else {
        icon = <i className="fa fa-times" />;
        msg = this.parseResultError(r.added, r.errMessage);
      }
      return (
        <tr key={String(i)} styleName={`result-${status}`}>
          <td style={{ whiteSpace: 'nowrap' }}>
            {icon}
          </td>
          <td style={{ whiteSpace: 'nowrap' }}>
            {msg}
          </td>
          {
            headers.map((h, idx) => (
              <td key={idx} style={{ whiteSpace: 'nowrap' }}>{r[h]}</td>            // eslint-disable-line
            ))
          }
        </tr>
      );
    });

    const succCount = _.filter(rows, r => _.has(r, 'added') && r.added === 'success').length;
    const failCount = _.filter(rows, r => _.has(r, 'added') && r.added !== 'success').length;

    return (
      <div>
        <Table
          className="aisz-table-light"
          responsive
          bordered
        >
          <thead>
            <tr>
              <th />
              <th>{this.intlMsg.msg('result.thead.status')}</th>
              {ths}
            </tr>
          </thead>
          <tbody>
            {trs}
          </tbody>
        </Table>
        <div styleName="result-summary">
          {this.intlMsg.msg('result.summary.seg1')}{': '}
          {succCount},{' '}
          {this.intlMsg.msg('result.summary.seg2')}{': '}
          {failCount},{' '}
          <Link onClick={this.handleReImport}>
            {this.intlMsg.msg('result.summary.reimport')}
          </Link>
          {' '}
          <Link onClick={() => this.props.pushState('/network/tdm')}>
            {this.intlMsg.msg('result.summary.back')}
          </Link>
        </div>
      </div>
    );
  }

  renderErrorModal() {
    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={!_.isNil(this.state.error)}
        onHide={() => this.setState({ error: null })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            { this.intlMsg.msg('err.modalheader') }
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            333333
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const breadcrumb = [{
      content: 'TDM',
      onClick: () => this.props.pushState('/network/tdm'),
    }, {
      content: this.intlMsg.msg('node.title'),
      active: true,
    }];

    const helpHeader = (
      <span>
        <i className="fa fa-book" />{' '}
        {this.intlMsg.msg('help.panelheader')}
      </span>
    );

    const { view } = this.state;

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Panel bsStyle="aisz-white">
                {view === 'dropzone' && this.renderDropzone()}
                {view === 'preview' && this.renderPreview()}
                {view === 'result' && this.renderResult()}
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Panel bsStyle="aisz-white" header={helpHeader}>
                <code>
                  name,deveui,nodetype,sf,gateway,remark
                </code><br />
                <code>
                  gongtu-001,3a8dec3194fa36ce,功图,7,123456fffe7890ab,备注
                </code>
              </Panel>
            </Col>
          </Row>
        </Grid>
        <div>
          {this.renderErrorModal()}
        </div>
      </div>
    );
  }
}

BatchNodes.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
  networkDetail: state.tdm.getNetwork,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(BatchNodes, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/BatchNodes/index.jsx